module.exports = __webpack_public_path__ + "img/logo_color.0a7ea747.png";